import type { MouseEvent } from 'react';
import { ToastContainer, TypeOptions } from 'react-toastify';
import { AlertTriangle, CheckCircle2, Info, X, XCircle } from 'lucide-react';

function ToastIcon({ type }: { type?: TypeOptions }) {
    const common = { size: 18, strokeWidth: 2.25 } as const;
    switch (type) {
        case 'success':
            return <CheckCircle2 {...common} className="text-emerald-600" />;
        case 'error':
            return <XCircle {...common} className="text-red-500" />;
        case 'warning':
            return <AlertTriangle {...common} className="text-amber-500" />;
        case 'info':
        default:
            return <Info {...common} className="text-ryd-primary" />;
    }
}

function ToastCloseButton({ closeToast }: { closeToast?: (e: MouseEvent<HTMLElement>) => void }) {
    return (
        <button
            type="button"
            aria-label="Close notification"
            onClick={closeToast}
            className="ml-1 flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-[#94a3b8] transition hover:bg-[#F8F5FA] hover:text-ryd-primary"
        >
            <X size={14} strokeWidth={2.4} />
        </button>
    );
}

export default function AppToastContainer() {
    return (
        <ToastContainer
            position="top-right"
            autoClose={3200}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
            limit={4}
            icon={({ type }) => <ToastIcon type={type} />}
            closeButton={ToastCloseButton}
            toastClassName="ryd-toast"
            bodyClassName="ryd-toast-body"
            progressClassName="ryd-toast-progress"
        />
    );
}
